

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class APPCC_List_ManagedObject

class APPCC_List_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: departmentName
    set departmentName(value:string) {
        this.setValueForKey(value, 'departmentName');
    }
    get departmentName():string {
        return this.valueForKey('departmentName');
    }
    set departmentNamePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'departmentName');
    }
    get departmentNamePrimitiveValue():string {
        return this.primitiveValueForKey('departmentName');
    }

    // Property: info
    set info(value:string) {
        this.setValueForKey(value, 'info');
    }
    get info():string {
        return this.valueForKey('info');
    }
    set infoPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'info');
    }
    get infoPrimitiveValue():string {
        return this.primitiveValueForKey('info');
    }

    // Property: isDisabled
    set isDisabled(value:boolean) {
        this.setValueForKey(value, 'isDisabled');
    }
    get isDisabled():boolean {
        return this.valueForKey('isDisabled');
    }
    set isDisabledPrimitiveValue(value:boolean) {
        this.setPrimitiveValueForKey(value, 'isDisabled');
    }
    get isDisabledPrimitiveValue():boolean {
        return this.primitiveValueForKey('isDisabled');
    }

    // Property: name
    set name(value:string) {
        this.setValueForKey(value, 'name');
    }
    get name():string {
        return this.valueForKey('name');
    }
    set namePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'name');
    }
    get namePrimitiveValue():string {
        return this.primitiveValueForKey('name');
    }

    // Property: orderIndex
    set orderIndex(value:number) {
        this.setValueForKey(value, 'orderIndex');
    }
    get orderIndex():number {
        return this.valueForKey('orderIndex');
    }
    set orderIndexPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'orderIndex');
    }
    get orderIndexPrimitiveValue():number {
        return this.primitiveValueForKey('orderIndex');
    }

    // Property: periodicity
    set periodicity(value:number) {
        this.setValueForKey(value, 'periodicity');
    }
    get periodicity():number {
        return this.valueForKey('periodicity');
    }
    set periodicityPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'periodicity');
    }
    get periodicityPrimitiveValue():number {
        return this.primitiveValueForKey('periodicity');
    }
    // Relationship: department
    set department(value:Department) {
        this.setValueForKey(value, 'department');
    }
    get department():Department {
        return this.valueForKey('department') as Department;
    }

    // Relationship: tasks
    protected _tasks:MIOManagedObjectSet = null;
    get tasks():MIOManagedObjectSet {
        return this.valueForKey('tasks');
    }
    addTasksObject(value:APPCC_Task) {
        this._addObjectForKey(value, 'tasks');
    }
    removeTasksObject(value:APPCC_Task) {
        this._removeObjectForKey(value, 'tasks');
    }
}
